<template>
  <router-link :to="location">
    <slot>{{text}}</slot>
  </router-link>
</template>

<script>
export default {
  name: 'ContestPlayerLink',

  props: {
    contestPlayerId: {
      type: Object,
      required: true
    },

    label: {
      type: String,
      default: 'player'
    },
  },

  computed: {
    /** @returns {Object} */
    location() {
      const id = this.contestPlayerId;

      const loc = {
        name: 'contest_player',
        params: {
          contestId: id.contestId,
          playerId:  id.playerId,
        }
      };

      return loc;
    },

    /** @returns {string} */
    text() {
      const label = this.label;
      const playerIdStr = this.contestPlayerId.playerId.toString();

      if(label.length > 0) {
        return label + ' ' + playerIdStr;
      } else {
        return playerIdStr;
      }
    },
  }
};
</script>
